import { AxiosResponse, CancelToken } from 'axios'
import apiInstance from '../../backend-api.setup'
import { ApiPathConfig } from '../../../config/ApiPathConfig'
import { TagGroupInterface } from '../../../interface/TagGroupInterface'

export const getTopTagGroupsService = (
  cancelToken?: CancelToken,
): Promise<AxiosResponse<TagGroupInterface[]>> =>
  apiInstance.get(ApiPathConfig.TOP_TAG_GROUPS, { cancelToken })
